import { render, staticRenderFns } from "./ContainerFooter.vue?vue&type=template&id=4b794996&scoped=true"
import script from "./ContainerFooter.vue?vue&type=script&lang=js"
export * from "./ContainerFooter.vue?vue&type=script&lang=js"
import style0 from "./ContainerFooter.css?vue&type=style&index=0&id=4b794996&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b794996",
  null
  
)

export default component.exports